/**
 * Canonical Body State — public API.
 * See docs/architecture-spec.md.
 *
 * Phase 1 of the Spec→Code migration. Types only; no runtime behaviour
 * lives in this module.
 */

export * from './JointKeys';
export * from './Capabilities';
export * from './SubjectProfile';
export * from './Landmark';
export * from './CanonicalFrame';
export * from './StreamHeader';
export * from './EnrichedSeries';
export * from './InputAdapter';

/** Canonical schema version this build understands.
 *  Bumped per docs/architecture-spec.md §9. */
export const CANONICAL_SCHEMA_VERSION = '1.0.0';
